<template>
  <div class="container px-6 mx-auto grid dark:bg-gray-900">
    <h2
      class="my-6 text-2xl font-semibold text-gray-700 dark:text-gray-200 text-left"
    >
      Nomina: Recibo de pago
    </h2>
    <form @submit.prevent="" autocomplete="off">
      <div class="grid gap-6 mb-8 md:grid-cols-2 lg:grid-cols-3">
        <!-- Card -->
        <div
          class="flex items-center p-4 bg-white rounded-lg shadow dark:bg-gray-800"
        >
          <div
            class="p-3 mr-4 text-blue-500 bg-blue-100 rounded-full dark:text-blue-100 dark:bg-blue-500"
          >
            <i class="icon-doc"></i>
          </div>
          <div>
            <p
              class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400"
            >
              <select v-model="table" class="border-2 border-blue-500 rounded">
                <!-- <option :value="'hrpayroll'">Pre-nomina</option> -->
                <option :value="'hrpayroll_history'">Recibo de pago</option>
              </select>
            </p>
          </div>
        </div>
        <!-- Card -->
        <div
          class="flex items-center p-4 bg-white rounded-lg shadow dark:bg-gray-800"
        >
          <div
            class="p-3 mr-4 text-blue-500 bg-blue-100 rounded-full dark:text-blue-100 dark:bg-blue-500"
          >
            <i class="icon-docs"></i>
          </div>
          <div>
            <p
              class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400"
            >
              <select
                v-model="printFormat"
                class="border-2 border-blue-500 rounded"
              >
                <option :value="1">1er Formato: Incluye neto.</option>
                <option :value="2">2do Formato: Sin neto.</option>
              </select>
            </p>
            <p>
              <label
                class="inline-flex items-center ml-6 text-gray-600 dark:text-gray-400"
              >
                <input
                  type="radio"
                  class="text-blue-500 form-radio focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray"
                  v-model="fColor"
                  :value="true"
                />
                <span class="ml-2">Full color</span>
              </label>
              <label
                class="inline-flex items-center ml-6 text-gray-600 dark:text-gray-400"
              >
                <input
                  type="radio"
                  class="text-blue-500 form-radio focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray"
                  v-model="fColor"
                  :value="false"
                />
                <span class="ml-2">Blanco</span>
              </label>
            </p>
          </div>
        </div>
        <!-- Card -->
        <!-- Card -->
        <div
          class="flex items-center p-4 bg-white rounded-lg shadow dark:bg-gray-800"
        >
          <div
            class="p-3 mr-4 text-blue-500 bg-blue-100 rounded-full dark:text-blue-100 dark:bg-blue-500"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <div>
            <p
              class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400"
            >
              <label
                class="inline-flex items-center text-gray-600 dark:text-gray-400"
              >
                <input
                  type="radio"
                  class="text-blue-500 form-radio focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray"
                  v-model="currency"
                  :value="true"
                />
                <span class="ml-2">USD</span>
              </label>
              <label
                class="inline-flex items-center ml-6 text-gray-600 dark:text-gray-400"
              >
                <input
                  type="radio"
                  class="text-blue-500 form-radio focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray"
                  v-model="currency"
                  :value="false"
                />
                <span class="ml-2">VEF</span>
              </label>
            </p>
          </div>
        </div>
        <!-- Card -->

        <!-- Card -->
        <div
          class="flex items-center p-4 bg-white rounded-lg shadow dark:bg-gray-800"
        >
          <div
            class="px-3 py-2 mr-4 text-blue-500 bg-blue-100 rounded-full dark:text-blue-100 dark:bg-blue-500"
          >
            <i class="icon-list-bullet"></i>
          </div>
          <div>
            <Multiselect
              v-model="transaction"
              tag-placeholder="Add"
              placeholder="Tipo de transaccion"
              label="name"
              track-by="code"
              :options="options"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
            ></Multiselect>
          </div>
        </div>
        <!-- Card -->
        <!-- Card -->
        <div
          class="flex items-center p-4 bg-white rounded-lg shadow dark:bg-gray-800"
        >
          <div
            class="px-3 py-2 mr-4 text-blue-500 bg-blue-100 rounded-full dark:text-blue-100 dark:bg-blue-500"
          >
            <i class="icon-users"></i>
          </div>
          <div>
            <Multiselect
              v-model="employees"
              tag-placeholder="Add"
              placeholder="Empleados"
              label="name"
              track-by="code"
              :options="objEmployees"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
            ></Multiselect>
          </div>
        </div>
        <!-- Card -->

        <!-- Card -->
        <div
          class="flex items-center p-4 bg-white rounded-lg shadow dark:bg-gray-800"
        >
          <div
            class="px-4 py-2 mr-4 text-green-500 bg-green-100 rounded-full dark:text-green-100 dark:bg-green-500 hidden lg:block"
          >
            <i class="icon-calendar"></i>
          </div>
          <div>
            <label for="">
              Desde:
              <input
                v-model="fromDate"
                type="date"
                required="required"
                class="border-2 border-gray-300 rounded"
              />
            </label>
            <br />
            <label for="">
              Hasta:
              <input
                v-model="toDate"
                type="date"
                required="required"
                class="border-2 border-gray-300 rounded mt-1 ml-1"
              />
            </label>
          </div>
        </div>
        <!-- Card -->

        <!-- Card -->
        <div
          class="flex items-center p-4 bg-white rounded-lg shadow dark:bg-gray-800"
        >
          <div
            class="px-4 py-2 mr-4 text-green-500 bg-green-100 rounded-full dark:text-green-100 dark:bg-green-500"
          >
            <i class="icon-doc-text"></i>
          </div>
          <div>
            <button
              type="button"
              @click.prevent="processReport"
              class="bg-green-600 hover:bg-green-700 px-3 py-1 rounded text-white"
            >
              Generar Reporte
            </button>
          </div>
        </div>
        <!-- Card -->
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import { jsPDF } from "jspdf";
import Axios from "axios";

export default {
  name: "TransactionPayroll",
  components: {
    Multiselect,
  },
  props: {},
  data() {
    return {
      URL: process.env.VUE_APP_URL,
      currency: true,
      fromDate: "",
      toDate: "",
      printFormat: 1,
      fColor: true,
      transaction: [],
      options: [],
      options2: [],
      employees: [],
      objEmployees: [],
      objEmployees2: [],
      table: "hrpayroll_history",
    };
  },
  mounted() {
    this.ComboTransactionType();
    this.getEmployees();
  },
  computed: {
    ...mapState(["user", "access_token"]),
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.transaction.push(tag);
    },
    async ComboTransactionType() {
      const URL = `${this.URL}combo-trans-type/${this.user.countryId}/${this.user.companyId}`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.access_token.replace(/['"]+/g, "")}`,
        },
      };

      try {
        let res = await Axios.get(URL, fetchConfig);

        this.options2 = res.data.map((item) => {
          return {
            name: `${item.transactionTypeCode}-${item.transactionTypeName}`,
            code: item.transactionTypeCode,
            display: item.display,
          };
        });
        this.options = res.data.map((item) => {
          return {
            name: `${item.transactionTypeCode}-${item.transactionTypeName}`,
            code: item.transactionTypeCode,
          };
        });

        console.log(this.options3);
        if (res.data.length > 0) {
          // inserta un valor al principio de un array

          this.options.unshift({ name: "TODO", code: "all" });
        }

        console.log(this.options);
      } catch (error) {
        Object.keys(error).forEach((key) => {
          // console.log(error[key])
        });
      }
    },
    async getEmployees() {
      const URL = `${this.URL}hr-employees/${this.user.countryId}/${this.user.companyId}`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.access_token.replace(/['"]+/g, "")}`,
        },
      };

      try {
        let employees = await Axios.get(URL, fetchConfig);
        this.objEmployees2 = employees.data.map((item) => {
          return { name: item.shortName, code: item.staffCode };
        });
        this.objEmployees = employees.data.map((item) => {
          return { name: item.shortName, code: item.staffCode };
        });
        // console.log(employees.data)
        if (employees.data.length > 0) {
          // inserta un valor al principio de un array
          // this.objEmployees.unshift({ name: 'TODO', code: 'all'})
        }

        console.log(this.objEmployees);
        console.log(this.objEmployees2);
      } catch (error) {
        Object.keys(error).forEach((key) => {
          // console.log(error[key])
        });
      }
    },
    formatDate() {
      function formatZero(n) {
        if (n < 10) {
          n = "0" + n;
          return n;
        } else {
          return n;
        }
      }

      let dataTime = new Date();
      let dd = dataTime.getDate();
      let mm = dataTime.getMonth() + 1;
      let yyyy = dataTime.getFullYear();
      dd = formatZero(dd);
      mm = formatZero(mm);
      return dd + "/" + mm + "/" + yyyy;
    },
    async processReport() {
      let updatedPeriod = 1;

      if (this.fromDate === "") {
        alert("Fecha es requerida");
        return;
      }

      const URL = `${this.URL}report-by-transaction`;
      if (this.table !== "hrpayroll_history") {
        updatedPeriod = 0;
      }
      const URL1 = `${this.URL}get-payroll-number/${this.user.countryId}/${this.user.companyId}/${this.fromDate}/${this.toDate}/${updatedPeriod}/payroll`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.access_token.replace(/['"]+/g, "")}`,
        },
      };

      let transaction = this.transaction;
      let employees = this.employees;

      let transactionAll = transaction.filter(
        (item) =>
          item["code"] === "all" ||
          item["code"] === "allinclusive" ||
          item["code"] === "noninclusive"
      );

      // let employeesAll = employees.filter(item => item['code'] === 'all'); //desabilitado para recibo de pago
      // console.log(transactionAll)
      // return
      if (transactionAll.length > 0) {
        if (transactionAll[0].code === "all") {
          transaction = this.options2;
        } else if (transactionAll[0].code === "allinclusive") {
          transaction = this.options2.filter((e) => e.display === 1);
        } else if (transactionAll[0].code === "noninclusive") {
          transaction = this.options2.filter((e) => e.display === 0);
        }
      }
      //  desabilitado para recibo de pago
      // if (employeesAll.length > 0) {
      //     employees = this.objEmployees2
      // }
      // console.log(transaction)
      // return
      let res = await Axios.get(URL1, fetchConfig);
      let payrollNumber = res.data.payrollNumber;
       //console.log(payrollNumber)
       //return
      if (payrollNumber === null) {
        alert("No se encontraron datos para el periodo seleccionado");
        return;
      }

      const params = {
        transaction: transaction,
        employees: employees,
        payrollNumber: payrollNumber.payrollNumber,
        countryId: this.user.countryId,
        companyId: this.user.companyId,
        table: this.table,
        report: "payment",
        year: payrollNumber.year,
      };
      // console.log(params)
      let res1 = await Axios.post(URL, params, fetchConfig);
      let data = res1.data.data;
      console.log(data);
      // return
      if (data === "empty") {
        alert("No se encontraron datos");
        return;
      }
      const selecCurrency1 = this.currency;
      let staff = data[2][0].staffName ?? "Employee";
      let idDocument = data[2][0].idDocument ?? "0";
      let period = data[0].payrollName;
      let country = this.user.country;
      let company = this.user.companyName;
      let logo = this.user.logo;
      let payrollTypeName = data[0].payrollTypeName;
      let companyAddress = this.user.companyAddress;
      let companyNumber = this.user.companyNumber;
      let shortCompany = data[0].companyId;
      let color = this.user.color;
      let userProcess = data[0].userProcess;
      let dataTimes = this.formatDate();
      dataTimes = dataTimes.toString();
      let configReport = data[1];
      let colorPri1;
      let colorPri2;
      let colorPri3;
      let colorSec1;
      let colorSec2;
      let colorSec3;
      let textColorPinc;
      let textColorSecu;
      let totalAsignacion;
      let totalDeduccion;
      let printFormat = this.printFormat;

      !this.fColor && (color = "WHITE");

      if (selecCurrency1) {
        totalAsignacion = data[0].totalAsignacion;
        totalDeduccion = data[0].totalDeduccion;
      } else {
        totalAsignacion = data[0].totalAsignacionLocal;
        totalDeduccion = data[0].totalDeduccionLocal;
      }

      // para la plantilla de colores
      switch (color) {
        case "YELLOW":
          textColorPinc = 0;
          textColorSecu = 0;
          colorPri1 = 230;
          colorPri2 = 219;
          colorPri3 = 153;
          colorSec1 = 242;
          colorSec2 = 237;
          colorSec3 = 209;
          break;
        case "BLUE":
          textColorPinc = 0;
          textColorSecu = 0;
          colorPri1 = 113;
          colorPri2 = 160;
          colorPri3 = 228;
          colorSec1 = 160;
          colorSec2 = 229;
          colorSec3 = 251;
          break;
        case "GRAY":
          textColorPinc = 255;
          textColorSecu = 0;
          colorPri1 = 57;
          colorPri2 = 54;
          colorPri3 = 104;
          colorSec1 = 219;
          colorSec2 = 219;
          colorSec3 = 219;
          break;
        case "DARKBLUE":
          textColorPinc = 255;
          textColorSecu = 0;
          colorPri1 = 2;
          colorPri2 = 34;
          colorPri3 = 104;
          colorSec1 = 72;
          colorSec2 = 163;
          colorSec3 = 205;
          break;

        default:
          textColorPinc = 0;
          textColorSecu = 0;
          colorPri1 = 255;
          colorPri2 = 255;
          colorPri3 = 255;
          colorSec1 = 255;
          colorSec2 = 255;
          colorSec3 = 255;
          break;
      }

      let imgLogoURL = window.location.origin + "/" + logo;
      // console.log(imgLogoURL)

      function toDataUrl(src, callback) {
        let xhttp = new XMLHttpRequest();
        xhttp.onload = function () {
          let fileReader = new FileReader();
          fileReader.onloadend = function () {
            callback(fileReader.result);
          };
          fileReader.readAsDataURL(xhttp.response);
        };
        xhttp.responseType = "blob";
        xhttp.open("GET", src, true);
        xhttp.send();
        // console.log(xhttp)
      }
      function crearPDF(imgData) {
        let doc = new jsPDF("p", "pt", "letter");

        // determino la cantidad de paginas en el documento
        let numPage = 1;
        let cont = 155;
        for (let i = 0; i < data.length; i++) {
          const element = data;
          // condiciono que comienze a leer los datos a partir de la posicion 11 del array
          if (i > 0) {
            element[i].forEach((element2) => {
              // doc.text( 'text test11', 220, cont ); //######### only test
              cont += 15; //18 es el tamaño aproximado de separacion entre lineas de palabras
              if (cont > 720) {
                //720 es el tamaño establecido de contenido dento de la hoja letter
                numPage = numPage + 1;
                // doc.addPage(); //######### only test
                cont = 155; // 155 es el espacion definido para la cabecera
              }
              // doc.text( 'text test2', 220, cont ); //######### only test
            });
            cont += 20;
          }
        }

        doc.setDrawColor(0);
        doc.setFillColor(colorPri1, colorPri2, colorPri3); // color de los rectangulos
        doc.rect(30, 25, 550, 20, "F");

        const ICONOS = {
          icoMap:
            "data:image/png;base64,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",
          icoPhone:
            "data:image/png;base64,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",
          icoGlobe:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAzCAYAAADVY1sUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL7SURBVHgB7VqLcdswDH3JdQB1AnODaAR1g25QdgNvEHcCuxM4nSDdQO4ETieQO4HTCVLBthoEESVApBKdz+8Od7QNgHgU+BFoYDzktZS17Gt5quW+FoeJIqvltpYv4nv63BCQInX9yYfDO6DAcbQpsApHQg1ytBPgUjD97OSDvl/jjQhlp854UB7tQXWJJO/F76MSakuXSujcop9EIwthW7X49kiMZSAYz3Qc9CRIaFD4U1kE9JZIAOqo7AjGMd05bETkU8kQXiC2eEnaTGLbEcRPoV/BTmQvfHQN2mAy254gPNMtYCfRSMH8+B7dLYxYKgJwTH+t0A/JivnJFPrqOeMVzuTIVAobbXr1ZQLJHD1wyqBWwuYpUmbM30pJ3vHAr1/yUB8VNqxdIB6fWPtBoU8pGEwxB/0I5sxOM4JjPeGihYd6wlqWTK3IObdX2pWNwQdm/OskfXgUn7/X8gNxkD6/ImIDvGAKuMJxcnmDDR1NmpWFJv1npEGM38NiQQaWick7GHJQDAnf5LzR1tM+UsAGPjFTTkjuawcbciJyg+FISWTG2o+wwRERBxsq1h5ribQSuRlCZIrIrnEeOBsih9OvNR8niXMhsiMimvM/x0eMg7+sbV0ND0T+wIaYjasLMRvt7yFPxKG981jEEHmg9xE6rDmLEWtvavmGNNiw9s7od4MLJoYr1vbQgXKZl0vpWB975orxeSe/oBf5IcUHTUFNXUQ4QVt8kPXnAwpDxzNml7oclBvs/pel+FlrE2LYAmtBrQ/ch4MOd+jo20H3WFOXTHPmb1DJtA2a9/CURexK+CoVNnMooRmVzKgfkjXzo7lWWMGIs7joIfRdvZVCX7tkdqXVfQ+J0e4RNbeyXcKvBtxYJDhCc2DBdLpuZUPimL1HojnRB4/Xq5Pc5RfQk5ABtvlWr05WOBw3otCkt/yFwzE7L35/s38SOTwToqB4/hboJ5ILfw35Emmu8sxwOKaITAGPMAnforvAhC92HJ6XU8p3Gu0cF3TjH2L2H0VgekrQAAAAAElFTkSuQmCC",
          icoMail:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAmCAYAAACGeMg8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG6SURBVHgB7VnbcYMwEFwnDVCCPvPpEijBHYQO4s/84Q5MB6YDpwPSgd0BdIA7IJyRJhiONzIS4505PDDotCstOpCBf/h5xHlklsQlDw8VnA0l2yeIO96lqm/Yi488NhsUU7SF3UhISIYV4A0rwaqE/MJ+XOkgYFf94OqJUIqcPALDCXMRSu417A0k2xR7dEDAbKsRN7bunVHyWElMCCxOuhrEtWqlrbzeOlWmWC1t4PdVuuehwYlRLLCs1WLUreRIrlmTENVQMA2XWNUC8FaKmXsbk/iow0MxzboFpGC+NfBopd5ClNVEJZmAXqtdwDsi6mjXmZhIu6jjoEFEwPTjot/A9e7En9DJ2ME6DsgxedrpfMqncgR+pYwG5hk1eh7qOIzIxdWGHcYtKKNH8oj+S2MfKzkYZqXZhChCokKIzsOWNifoKbqTGlM0vT64KJ6dVEYE/oH+xDy1aXKCNqu1YaqVtAlRVvPQDRfzF9VZk6mIpKDyDDnyWqSjz2fsayXyV0AjXht0puElxDSQkBvsx42EXGE/fuhAL3rP+HzVFcRdKEUu7Nz/TSX3ex0pYwd7/r1KUFjq/oz/Ad4q72Jw+8N+AAAAAElFTkSuQmCC",
          logo: imgData,
        };

        const COMPONENT = {
          userProcess,
          dateTime: dataTimes,
          period,
          payrollTypeName,
          country,
          company,
          companyNumber,
          companyAddress,
          shortCompany,
          staff,
          idDocument,
        };
        let n = 155; // Utilizada para asignar el numero de posisionamiento del salto de linea inicial

        // numero de pagina
        doc.setFontSize(7.5);
        doc.setFont("helvetica", "italic");
        doc.text(`Page: 1/${numPage}`, 549, 20);
        doc.text(`Page: 1/${numPage}`, 549, 760);
        doc.setFont("helvetica", "normal");
        // dibuja linea donde aparece los conceptos. Se puede eliminar a futuro
        doc.setDrawColor(0);
        doc.setFillColor(colorSec1, colorSec2, colorSec3);
        doc.rect(30, 117, 550, 20, "F");
        configReport.forEach((element) => {
          n = element.fieldType === "bodyStart" ? parseInt(element.value) : 155; // indica la posision de lsalto de linia inicial que viene desde base de dato
          // console.log(element.find(bodyStart));
          if (element.fieldType === "text") {
            doc.setFont("helvetica", element.fontType);
            doc.setFontSize(element.size);
            doc.setTextColor(element.r, element.g, element.b);
            doc.text(element.value, element.x1, element.y1);
            doc.setTextColor(textColorSecu, textColorSecu, textColorSecu);
            doc.setFont("helvetica", "normal");
          }
          if (element.fieldType === "JPEG") {
            const ICOLOGO = ICONOS[element.value];
            doc.addImage(
              ICOLOGO,
              element.fieldType,
              element.x1,
              element.y1,
              element.width,
              element.high
            );
          }
          if (element.fieldType === "component") {
            const COMP = COMPONENT[element.value];
            doc.setFont("helvetica", element.fontType);
            doc.setFontSize(element.size);
            doc.setTextColor(element.r, element.g, element.b);
            doc.text(COMP, element.x1, element.y1);
            doc.setTextColor(textColorSecu, textColorSecu, textColorSecu);
            doc.setFont("helvetica", "normal");
          }
          console.log(element);
        });

        // pie de pagina
        doc.setFontSize(7.5);
        doc.setFont("helvetica", "italic");
        doc.text(`Designed By Rivero Visual Group`, 250, 775);
        doc.setFont("helvetica", "normal");

        let nRectangulo = 2;
        let nunIniRectangulo = 145;

        function formatNumber(number, currencyCurrent) {
          number = parseFloat(number);
          number = number.toFixed(2);
          if (currencyCurrent) {
            let montoNuevo = number
              .toString()
              .replace(/\D/g, "")
              .replace(/([0-9])([0-9]{2})$/, "$1.$2")
              .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
            return `${montoNuevo}`;
          } else {
            let montoNuevo = number
              .toString()
              .replace(/\D/g, "")
              .replace(/([0-9])([0-9]{2})$/, "$1,$2")
              .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ".");
            return `${montoNuevo}`;
          }

          // let num = parseFloat(number).toFixed(2);
          // return num
        }

        for (let i = 0; i < data.length; i++) {
          const element = data;
          // console.log('length: '+element[i].length)
          let contador = 0;
          // console.log(element[i])
          // condiciono que comienze a leer los datos a partir de la posicion 1 del array
          if (i > 1) {
            let name = true;

            element[i].forEach((item) => {
              // console.log(item)
              // indica si imprime linea amarilla
              if (nRectangulo % 2 == 0) {
                doc.setDrawColor(0);
                doc.setFillColor(colorSec1, colorSec2, colorSec3);
                doc.rect(30, nunIniRectangulo, 550, 15, "F");
              }

              if (name) {
                doc.line(30, n - 10, 580, n - 10); //horizontal line
                doc.setFont("helvetica", "bold");

                doc.text(item.staffCode, 30, n);
                doc.text(item.staffName, 96, n);
                name = false;
                doc.setFont("helvetica", "normal");
              }

              doc.line(203, n - 10, 203, n + 5); // vertical line
              doc.line(329, n - 10, 329, n + 5); // vertical line
              doc.line(365, n - 10, 365, n + 5); // vertical line
              doc.line(448, n - 10, 448, n + 5); // vertical line
              doc.line(510, n - 10, 510, n + 5); // vertical line
              doc.text(item.transactionTypeName, 205, n);
              doc.text(item.quantity, 361, n, "right");

              // validacion de moneda
              let amount = item.amount;
              if (selecCurrency1 === false) {
                amount = item.localAmount;
              }
              if (item.isIncome == 1) {
                if (amount == null) {
                  //  console.log('entro')
                  // doc.text('0', 436, n, 'right' );
                } else {
                  doc.text(
                    formatNumber(amount, selecCurrency1),
                    445,
                    n,
                    "right"
                  );
                }
              }
              if (item.isIncome == 0) {
                if (amount == null) {
                  // console.log('entro')
                  // doc.text('0', 502, n, 'right' );
                } else {
                  doc.text(
                    formatNumber(amount, selecCurrency1),
                    508,
                    n,
                    "right"
                  );
                }

                // doc.text( '2.07', 502, 155, 'right' );
              }

              n += 15;

              nunIniRectangulo += 15;
              nRectangulo += 1;

              contador++;

              if (contador >= element[i].length) {
                // indica si imprime linea amarilla
                if (nRectangulo % 2 == 0) {
                  doc.setDrawColor(0);
                  doc.setFillColor(colorSec1, colorSec2, colorSec3);
                  doc.rect(30, nunIniRectangulo, 550, 15, "F");
                }
                doc.setFontSize(7.5);
                // doc.line(193, n-10, 193, n+5); // vertical line
                // doc.line(309, n-10, 309, n+5); // vertical line
                doc.line(365, n - 10, 365, n + 5); // vertical line
                doc.line(448, n - 10, 448, n + 5); // vertical line
                doc.line(510, n - 10, 510, n + 5); // vertical line
                doc.setFont("helvetica", "bold");
                doc.text("TOTALES", 215, n);

                // asignacion para los montos
                let asignacion;
                let deduccion;
                if (selecCurrency1 === false) {
                  asignacion = item.asignacionLocal;
                  deduccion = item.deduccionLocal;
                } else {
                  asignacion = item.asignacion;
                  deduccion = item.deduccion;
                }

                if (asignacion === null) {
                  asignacion = 0;
                  // doc.text(`${asignacion}`, 436, n, 'right' );
                } else {
                  doc.text(
                    `${formatNumber(asignacion, selecCurrency1)}`,
                    445,
                    n,
                    "right"
                  );
                }
                if (deduccion === null) {
                  deduccion = 0;
                  // doc.text(`${deduccion}`, 502, n, 'right' );
                } else {
                  doc.text(
                    `${formatNumber(deduccion, selecCurrency1)}`,
                    508,
                    n,
                    "right"
                  );
                }

                let total = asignacion - deduccion; // calculo para el total
                // console.log('total: ' + total);
                if (printFormat === 1) {
                  doc.text(
                    `${formatNumber(total, selecCurrency1)}`,
                    578,
                    n,
                    "right"
                  );
                  // doc.text(total, 574, n, 'right' );
                }

                doc.setFont("helvetica", "normal");
                nunIniRectangulo += 20;
                nRectangulo += 1;
                n += 20;
              }
            });
          }
        }

        doc.setFont("helvetica", "bold");
        let totalNeto = totalAsignacion - totalDeduccion;
        n = n + 5;
        if (selecCurrency1) {
          doc.text(`TOTAL GENERAL USD.`, 215, n);
        } else {
          doc.text(`TOTAL GENERAL VEF.`, 215, n);
        }
        doc.text(
          ` ${formatNumber(totalAsignacion, selecCurrency1)}`,
          445,
          n,
          "right"
        );
        doc.text(
          ` ${formatNumber(totalDeduccion, selecCurrency1)}`,
          508,
          n,
          "right"
        );

        if (printFormat === 1) {
          doc.text(
            ` ${formatNumber(totalNeto, selecCurrency1)}`,
            578,
            n,
            "right"
          );
        }

        doc.save(`Recibo ${staff}-${company}-${period}.pdf`);
      } //End crearPDF()

      // llamo la funcion para combertir imagen a base64 y le paso por parametro la variable ' imgLogoURL' con la URL
      toDataUrl(imgLogoURL, function (dataURL) {
        // como callback llamo una funcion para crear el pdf y le paso por varible 'dataURL' la imagen convertida en base64
        crearPDF(dataURL);
      });
    }, //End processReport()
  },
};
</script>

<style></style>
